import { TeamAccessDTO } from '../team/team-access.dto';
import { WikiCategoryListDTO } from '../wiki-category/wiki-category-list.dto';
import { UserListDTO } from '../user/user-list.dto';

export class WikiPostDTO extends TeamAccessDTO {

    title: string;

    content: string;

    author: UserListDTO;

    categories: Array<WikiCategoryListDTO>;

}
